import React, { useState, useEffect, useContext, useRef } from "react";
import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
// import Sidebar from "../components/dashboard/sidebar";
import SideMenu from "./student/SideMenu";
import { useNavigate, Link } from "react-router-dom";
import { useParams } from 'react-router-dom';
import tmdbApi from "../api/tmdbApi";
import axios from 'axios';
import moment from "moment";
import Editor from 'react-simple-wysiwyg';
import Select from 'react-select';
import Loader from "../components/loader";
import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { v4 as uuid } from 'uuid';
import { Uploader } from "../utils/upload"
import SessionPopup from "./SessionPopup"
import { LazyLoadImage } from "react-lazy-load-image-component";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import "react-lazy-load-image-component/src/effects/blur.css";
import OpenSeadragon from "openseadragon";
import deepZoom from "../assets/images/icons/Dna-dz.svg";
import DateTimeRangePicker from "../components/DateTimeRangePicker";

import dayjs from "dayjs";

let { lambda, country, appname } = window.app;
const getYouTubeVideoId = (url) => {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url?.match(regExp);
    return match && match[7].length === 11 ? match[7] : null;
};

const customComponents = {
    DropdownIndicator: () => null, // Remove the dropdown indicator
    IndicatorSeparator: () => null, // Optionally remove the separator
};

// Cases table, same look as the Modules list table (no grid lines, striped rows)
const caseTableStyle = { width: "100%", borderCollapse: "collapse", border: "1px solid #e3e7ef" };
const caseThStyle = { padding: "12px 10px", fontSize: "12px", fontWeight: 700, textTransform: "uppercase", color: "#000", backgroundColor: "#fff", border: "none", whiteSpace: "nowrap" };
const caseTdStyle = { padding: "8px 10px", fontSize: "13px", fontWeight: 500, color: "#000", verticalAlign: "middle", border: "none" };
const caseRowBg = (index) => (index % 2 === 0 ? "#eef2fb" : "#fff");

const EditTest = () => {
    const transformRef = useRef(null);
    const viewerRef = useRef(null);

    const inputRef = useRef(null);

    let { id } = useParams();
    const navigate = useNavigate();
    const [msg, setMsg] = useState("");
    const [selectedCases, setSelectedCases] = useState([]);
    const [cases, setCases] = useState([]);
    const [errors, setErrors] = useState({});


    const [youtube, setYoutube] = useState(null);
    const [baseUrl, setBaseUrl] = useState("https://qih3mm5tl8.execute-api.ap-south-1.amazonaws.com/prod/")
    const [partsize, setPartsize] = useState(100)
    const [numuploads, setNumuploads] = useState(3)
    const [ta, setTa] = useState(undefined)
    const [pgvalue, setPgvalue] = useState(undefined)
    const [perf, setPerf] = useState(undefined)


    const [youtubeError, setyoutubeError] = useState('');
    const [descriptionError, setdescriptionError] = useState('');
    const [statusError, setstatusError] = useState('');
    const [explanationError, setexplanationError] = useState('');
    const [tagError, settagError] = useState('');
    const [answer1Error, setanswer1Error] = useState('');
    const [answer2Error, setanswer2Error] = useState('');
    const [formData, setFormData] = useState('');

    const [caseIdDynamic, setCaseId] = useState(null);

    const [isLoading, setIsLoading] = useState(false);
    const [isUserAdd, setIsUserAdd] = useState(false);
    const [feeError, setFeeError] = useState('');
    const [nameError, setNameError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [IdcError, setIdcError] = useState('');
    const [typeError, setTypeError] = useState('');
    const [costError, setCostError] = useState('');

    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
    const [managertypeError, setManagerTypeError] = useState('');
    const [viewFormData, setViewFormData] = useState({
        "name": '',
        "description": '',
        "tags": '',
        "cost": null,
        "status": '',
        "cases": '',
        "videos": '',
    });
    const [permission, setPermission] = useState({});
    const [completedFiles, setCompletedFiles] = useState([]);

    const [success, setSuccess] = useState(false);

    const [UpdateSuccess, setUpdateSuccess] = useState(false);
    const [image, setImg] = useState('');
    const [imageCloudfront, setimageCloudfront] = useState('');

    const [manager, setManagers] = useState({});
    const [selectAll, setSelectAll] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [existmsg, setExistMsg] = useState(false);
    const [Ismsg, setIsMsg] = useState(false);

    const [imageErrorFiles, setImageErrorFiles] = useState([])
    const [fileSizeError, setFileSizeError] = useState(false);
    const [fileSizeErrorMsg, setFileSizeErrorMsg] = useState("");
    const [inputChange, setInputChange] = useState(true);
    const [questionData, setQuestionData] = useState(null);
    const [imagedisplay, setImageDisplay] = useState(false);
    const [resourceBucket, setResourceImg] = useState(false);

    const [toggleClearRows, setToggleClearRows] = useState(false);
    const [imagesUrls, setImageUrls] = useState(null);
    const [imageFiles, setImageFiles] = useState([])
    const [imageIndex, setImageIndex] = useState(0)
    const [alertPopup, setAlertPopup] = useState(false)
    const [alertMsg, setAlertMsg] = useState(false)
    const [deleteImage, setdeleteImage] = useState(false);
    const [deleteImageId, setDeleteImageId] = useState(null);
    const [deleteImageSuccess, setDeleteImageSuccess] = useState(false);
    const [successAPI, setSuccessAPI] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");

    const [uploadImg, setUploadImg] = useState(false);
    const [deleteimageType, setImageType] = useState(null);

    const [clinicalimageFiles, setclinicalImageFiles] = useState([])
    const [clinicalimagesUrls, setClinicalImageUrls] = useState(null);
    const [clinicalimageIndex, setClinicalImageIndex] = useState(0)

    const [uploadedFiles, setUploadedFiles] = useState([])

    const [cpcList, setCPCInfo] = useState([])

    // Deepzoom
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
    const [dziUrl, setDziUrl] = useState("");
    const [dziUrlFile, setDziUrlFile] = useState("");

    const [dzipopupImage, setDZIPopupImage] = useState(false);
    const [isPopupLoading, setPopupLoading] = useState(false);
    const [viewer, setViewer] = useState(null);
    const [resetpopup, setresetpopup] = useState(false);
    const [rotation, setRotation] = useState(0);
    const [loading, setLoading] = useState(false);


    const [selectedfileslist, setSelectedFiles] = useState([]);
    const [selectedVideosFiles, setSelectedVideosList] = useState([]);
    const [files, setFiles] = useState([]);
    const [tags, setTags] = useState([]);
    const [input, setInput] = useState("");
    const [showVideoPopup, setShowVideoPopup] = useState(false);
    const [showImagePopup, setShowImagePopup] = useState(false);
    const [popupImage, setPopupImage] = useState(null);
    const [answers, setAnswersData] = useState(null);
    const [filteredOptionsMap, setFilteredOptionsMap] = useState({});
    const [videos, setVideos] = useState([]); // Add this for videos list
    const [selectedVideos, setSelectedVideos] = useState([]); // Add this for selected videos
    const GetCpcCases = async () => {
        try {

            const response = await tmdbApi.cpcCaseInfoForModule();
            if (response?.result) {
                // console.log(response?.result, "---")
                setCases(response?.result?.questionData || []);
            }
        } catch {
            console.log("error");
        }
        finally {
            setLoading(false);
        }
    };
    const GetCpcCasesInfo = async (tmpCases) => {
        GetCpcCases()
        try {
            let tableName = id ? "moduleCases" : null

            const response = await tmdbApi.cpcCaseInfoForModule(tableName, tmpCases, id);
            if (response?.result) {
                // console.log(response?.result, "---")
                if (response?.result?.questionData.length > 0) {
                    let res = response?.result?.questionData?.map(item => {
                        return {
                            value: `${item.caseid}`,
                            // label: item.diagnosis,
                            label: item.diagnosisid
                                ? `${item.diagnosisid} ${item.diagnosis}`
                                : item.diagnosis || "",
                            diagnosisid: item.diagnosisid,
                            diagnosis: item.diagnosis,
                            files: item.files
                        }
                    })
                    // API doesn't guarantee order; restore the order the cases were saved in
                    const savedOrder = (tmpCases || []).map(String);
                    const rank = (c) => {
                        const i = savedOrder.indexOf(c.value);
                        return i === -1 ? Infinity : i;
                    };
                    res.sort((a, b) => rank(a) - rank(b));
                    setSelectedCases(res || []);
                }

            }
        } catch {
            console.log("error");
        }
    };
    const lectureLibraryInfo = async () => {
        try {
            const response = await tmdbApi.lectureLibraryInfo();
            if (response?.result) {
                console.log(response?.result?.data, "---")
                setVideos(response?.result?.data || []);
            }
        } catch {
            console.log("error");
        }
    };

    const handleCaseChange = (selectedOptions) => {
        setSelectedCases(selectedOptions);


    };
    console.log('selectedCasesssssssssssssssssssssssss', selectedCases)
    const handleVideoChange = (selectedOptions) => {
        setSelectedVideos(selectedOptions);
    };

    useEffect(() => {
        if (!localStorage.getItem("token")) navigate("/");
        // GetCpcCasesInfo();
        lectureLibraryInfo()

    }, []);

    const [checkStatus, setCheckStatus] = useState(false);
    const [invalidContent, setInvalidContent] = useState(false);
    const { route, setRoute, setCurrentPage, setRowsPerPage, setActiveMenuObj, usePrevious, userData, setActiveMenuId, GetTimeActivity } = useContext(contentContext);


    const styles = {
        container: {
            display: "flex",
            flexWrap: "wrap",
            padding: "5px",
            border: "1px solid #ccc",
            borderRadius: "6px",
            maxWidth: "400px"
        },
        tag: {
            display: "flex",
            alignItems: "center",
            background: "#e0e0e0",
            padding: "5px 10px",
            margin: "5px",
            borderRadius: "4px"
        },
        remove: {
            marginLeft: "8px",
            cursor: "pointer",
            color: "#888"
        },
        input: {
            flex: 1,
            border: "none",
            outline: "none",
            minWidth: "100px",
            padding: "5px",
            margin: "5px"
        }
    };

    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute !== route) {
            setCurrentPage(1)
            setRowsPerPage(15)
        }
    }, [prevRoute]);


    useEffect(() => {
        // console.log("imageFiles ,uploadedFiles, ", imageFiles, imageIndex, uploadedFiles)
        if (imageFiles && imageFiles?.length > 0 && uploadedFiles && uploadedFiles?.length > 0 && uploadedFiles?.length == imageFiles?.length) {
            //  updateFilesAPI()
        }
    }, [uploadedFiles]);


    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                    setimageCloudfront(window.site.common.imageCloudfront)
                    setResourceImg(window.site.common.resourceBucket)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            console.log('window.site.common', window.site.common)
            setImg(window.site.common.imageCloudfront)
            setimageCloudfront(window.site.common.imageCloudfront)
            setResourceImg(window.site.common.resourceBucket)
        }


    }, [window.site]);

    useEffect(() => {
        if (toastMessage) {
            toast.success(toastMessage, {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            // Clear the message after showing to prevent re-triggering
            setToastMessage("");
        }
    }, [toastMessage]);


    // useEffect(() => {
    //     if (selectedCases) {
    //         let selectedFilesList = getSelectedFiles(cases, selectedCases);
    //         console.log("selectedFilesList ", selectedFilesList)
    //         setSelectedFiles(selectedFilesList)
    //     }
    // }, [selectedCases]);
    useEffect(() => {
        if (!Array.isArray(selectedCases) || selectedCases.length === 0) {
            console.log("selectedCases is not ready yet");
            return;
        }

        if (!Array.isArray(cases) || cases.length === 0) {
            console.log("cases list is not ready yet");
            return;
        }

        const selectedFilesList = getSelectedFiles(cases, selectedCases);
        console.log("selectedFilesList", selectedFilesList);
        setSelectedFiles(selectedFilesList);
    }, [selectedCases, cases]);

    useEffect(() => {
        if (!Array.isArray(selectedVideos) || selectedVideos.length === 0) {
            console.log("selectedVideos is not ready yet");
            return;
        }

        if (!Array.isArray(videos) || videos.length === 0) {
            console.log("videos list is not ready yet");
            return;
        }

        console.log("selectedVideosList", videos, selectedVideos);
        const selectedVideosList = getSelectedVideoFiles(videos, selectedVideos);
        console.log("selectedVideosList", selectedVideosList);
        setSelectedVideosList(selectedVideosList);
    }, [selectedVideos, videos]);


    useEffect(() => {
        if (selectedVideos) {
            console.log("selectedVideosList ", videos, selectedVideos)
            let selectedVideosList = getSelectedVideoFiles(videos, selectedVideos);
            console.log("selectedVideosList ", selectedVideosList)
            setSelectedVideosList(selectedVideosList)
        }
    }, [selectedVideos]);

    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        setActiveMenuId(200005)
        setActiveMenuObj({
            "Client Management": false,
            "Contact Management": false,
            "Reports": false
        })
        setRoute("user")
        if (id) {
            getuser();


        }
        getCpcInfo()
        GetAnswersInfo()
        // getManagers();
        //  GetCountries();
        // userActivity();
    }, []);
    const GetAnswersInfo = async () => {
        try {
            const response = await tmdbApi.answerInfo();
            if (typeof response?.result === 'object') {
                let ans = response?.result?.answerData || [];
                if (ans.length > 0) {
                    let tmpArr = [];
                    ans.forEach(a => {
                        let obj = {
                            value: `${a.answerid}`,
                            label: a.answer
                        }
                        tmpArr.push(obj)
                    })
                    setAnswersData(tmpArr);

                    setFilteredOptionsMap({
                        answer1: tmpArr,
                        answer11: tmpArr,
                        answer2: tmpArr
                    })


                }

            }
        } catch {
            console.log("error");
        }
    };


    useEffect(() => {
        //  debugger
        if (!viewerRef.current) return;

        console.log("Loading OpenSeadragon with URL:", dziUrl);
        const isDziURL = dziUrl.includes("output.dzi");
        const { width, height } = imageDimensions; // Destructure imageDimensions for clarity


        const tileSource = isDziURL
            ? {
                Image: {
                    xmlns: "http://schemas.microsoft.com/deepzoom/2008",
                    Url: encodeURI(dziUrl),
                    Format: "jpeg",
                    Overlap: 2,
                    TileSize: 256,
                    Size: { Width: width, Height: height },
                },
            }
            : {
                type: "image",
                url: encodeURI(dziUrl),
                buildPyramid: false,
            };

        const osdViewer = OpenSeadragon({
            id: "openseadragon-viewer",
            prefixUrl: "https://openseadragon.github.io/openseadragon/images/",
            tileSources: tileSource,
            showNavigator: true,
            crossOriginPolicy: "Anonymous",
            navigatorPosition: "BOTTOM_RIGHT",
            maxZoomPixelRatio: 10,
            minZoomImageRatio: 0.5,
            visibilityRatio: 1,
            zoomPerScroll: 2,
            homeFillsViewer: true,
            gestureSettingsMouse: {
                clickToZoom: true,
                dblClickToZoom: true,
                flickEnabled: true,
                pinchToZoom: true,
                scrollToZoom: true,
            },
            showZoomControl: true,
            showHomeControl: true,
            showFullPageControl: true,
            showRotationControl: true,
            wrapHorizontal: false,
        });


        setViewer(osdViewer);

        return () => {
            if (osdViewer) {
                osdViewer.destroy();
            }
        };
    }, [dziUrl, imageDimensions]);
    const rotateImage = (angle) => {
        if (viewer) {
            const newRotation = (rotation + angle) % 360;
            viewer.viewport.setRotation(newRotation);
            setRotation(newRotation);
        }
    };

    const resetZoom = () => {
        if (viewer) {
            viewer.viewport.goHome();
            viewer.viewport.setRotation(0);
            setRotation(0);
        }
    };

    const closeDeepZoom = () => {
        setPopupOpen(false);
        setDziUrl("");
        setDziUrlFile("");
        setImageDimensions({ width: 0, height: 0 });
        if (viewer) {
            viewer.destroy();
            setViewer(null);
        }
    };



    const getCpcInfo = async () => {
        const response = await tmdbApi.cpcInfo("ACTIVE,UPCOMING");

        if (response?.result?.length > 0) {
            setCPCInfo(response?.result)
        }
    }

    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = id !== undefined ? path[path.length - 2] : path[path.length - 1];;
        var presentTime = moment();
        let payload;

        payload = {
            "userid": localStorage.getItem("userId"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


        const previousId = localStorage.getItem("previousid");
        const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)
                }
            });
    }


    const getuser = (e) => {
        setLoading(true)
        GetTimeActivity()
        const userId = localStorage.getItem("userId")
        const token = localStorage.getItem("token")
        axios({
            method: 'GET',
            url: lambda + '/moduleInfo?appname=' + appname + '&moduleid=' + id + '&token=' + token,
        })
            .then(function (response) {
                //  console.log("response", response?.data?.result?.[0]);
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                    // localStorage.clear();
                    // navigate("/")
                }
                else {
                    if (response?.data?.result?.data.length > 0) {
                        setViewFormData(response?.data?.result?.data?.[0]);
                        // console.log(response?.data?.result, "ccssd s");
                        if (response?.data?.result?.data?.[0]?.files && response?.data?.result?.data?.[0]?.files?.length > 0) {
                            let completedFiles = response?.data?.result?.data?.[0]?.files.filter(file => file.status === "COMPLETED") || [];
                            setCompletedFiles(completedFiles)
                        }
                        console.log(response?.data?.result?.data?.[0]?.cases, "cases")
                        let tmpCases = response?.data?.result?.data?.[0]?.cases?.map(i => i.value) || []
                        GetCpcCasesInfo(tmpCases);

                        setSelectedVideos(response?.data?.result?.data?.[0]?.videos || []);
                        //setSelectedCases(response?.data?.result?.data?.[0]?.cases || []);
                        setTags(response?.data?.result?.data?.[0]?.tags || [])

                        if (response?.data?.result?.[0] && response?.data?.result?.data?.[0]?.permissions) {
                            setPermission(response?.data?.result?.data?.[0]?.permissions)
                        }
                    } else {
                        setInvalidContent(true)
                    }
                }
                // getPermissions(response?.data && response?.data?.result && response?.data?.result?.[0] && response?.data?.result?.[0]?.type)
            });
    }

    const handleImageErrorDelete = (e, key) => {
        setImageErrorFiles(imageErrorFiles.filter(item => item.name !== key?.name));

    }

    const onclickInvalid = () => {
        GetTimeActivity()
        setInvalidContent(false)
        navigate('/')
    }

    const playVideo = (video) => {
        setShowVideoPopup(true);
        setYoutube(video);
    };

    const onDescriptionChange = (e, name) => {
        setViewFormData((prevData) => ({
            ...prevData,
            [name]: e.target.value // Update the 'description' field with Quill editor value
        }));
        setInputChange(false)
    };

    const handleImageDelete = (e, key) => {
        let imgUrls = { ...imagesUrls }
        let imgIndex = imageIndex
        // console.log('imgIndex ', imgIndex)
        // console.log('imgIndex ', imgUrls[key]?.name)

        // let targetIndex = imageFiles.findIndex((each) => {each.name == imgUrls[key]?.name});
        // imageFiles.splice(targetIndex-1, 1);
        setImageFiles(imageFiles.filter(item => item.name !== imgUrls[key]?.name));

        // setImageFiles((imageFiles) => {
        //     return [
        //         ...imageFiles.filter((item, i) => item.name != imgUrls[key]?.name)
        //     ]
        // })

        if (imgUrls[key]) {
            delete imgUrls[key]
        }
        setImageUrls(imgUrls)
        setImageIndex(imgIndex - 1)

    }

    const handleImageFileDelete = async (e, item, key, type) => {
        // console.log("item ", item)
        setdeleteImage(true)
        let obj = item
        obj["index"] = key
        setDeleteImageId(item)
        setImageType(type)
    }

    const handleFileChange = async (event) => {
        const selectedFiles = Array.from(event.target.files);
        setInputChange(false)
        let filesLength = 0
        if (viewFormData && viewFormData?.files?.length > 0) {
            filesLength = filesLength + viewFormData?.files.length
        }
        if (imageFiles && imageFiles?.length > 0) {
            filesLength = filesLength + imageFiles?.length
        }
        if (selectedFiles && selectedFiles?.length > 0) {
            filesLength = filesLength + selectedFiles?.length
        }


        if (filesLength > 10) {
            setAlertPopup(true)
            return;
        }
        //for multiple files
        setImageDisplay(true)
        // setImageFiles(selectedFiles)
        // setImageFiles((prevData) => ([
        //     ...prevData, // Keep the other fields intact
        //     selectedFiles
        // ]));

        Array.from(selectedFiles).map(async (file, index) => {
            console.log('file', file)
            // console.log('setImageIndex ', imageIndex, index)
            let fileSize = 1048612 * 20 // 5MB
            // if (file?.size < fileSize) {
            if (imageIndex > 0) {
                index = index + imageIndex
            }
            let urlobj = URL.createObjectURL(file)
            // let img = new Image();
            // img.onload = function () {
            // alert(this.width + " " + this.height);
            // if (this.width < 3841) {
            // if (this.width < 2000) {


            setImageFiles((prevData) => ([
                ...prevData, // Keep the other fields intact
                file
            ]));

            setImageUrls((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["blob" + index]: {
                    url: urlobj,
                    name: file?.name
                }, // Update the changed field
            }));
            setImageIndex(index + 1)
            // } else {
            //     setFileSizeError(true)
            //     setFileSizeErrorMsg("Resolution has been greater than 3840px and 2160px")
            //     // let obj = {
            //     //     name: file?.name,
            //     //     size: file?.size,
            //     //     width: this.width,
            //     //     height: this.height,
            //     //     error: "Resolution has been greater then 3840px and 2160px",
            //     //     url: urlobj
            //     // }
            //     // setImageErrorFiles((prevData) => ([
            //     //     ...prevData, // Keep the other fields intact
            //     //     obj
            //     // ]));
            // }
            // };
            //  img.src = urlobj;
            // } else {
            //     setFileSizeError(true)
            //     setFileSizeErrorMsg("File size greater than 20MB")
            // }


        })

    };





    const editCaseLink = (e, file) => {

        let path = "/EditModulecase/" + file?.caseid + "/" + id
        const fullUrl = `${window.location.origin}${path}`;
        window.open(fullUrl, "_blank");
    }

    const handleKeyDown = (e) => {
        if ((e.key === "Enter" || e.key === ",") && input.trim()) {
            e.preventDefault();
            const newTag = input.trim();
            if (tags && !tags.includes(newTag)) {
                setTags([...tags, newTag]);
            }
            setInput("");
        }
        if (e.key === "Backspace" && input === "" && tags.length > 0) {
            e.preventDefault();
            const updatedTags = [...tags];
            const lastTag = updatedTags.pop();
            setTags(updatedTags);
            setInput(lastTag);
        }
    };

    const removeTag = (indexToRemove) => {
        setTags(tags.filter((_, index) => index !== indexToRemove));
    };



    const handleClickContainer = () => {
        inputRef.current.focus();
    };



    const handlePopupImage = (imageUrl) => {
        console.log('imageUrl', imageUrl)
        setShowImagePopup(true)
        setPopupImage(imageUrl)
    }



    const handleChange = (e) => {
        const { name, value } = e.target;


        if (name === "usertype") {
            if (id) {
                setCheckStatus(true);
            }
            setViewFormData(prev => ({ ...prev, [name]: value }));
        }



        if (name === "phone") {
            let formattedValue = value;
            let numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters
            const currentIdc = viewFormData?.idc?.trim(); // Remove unnecessary spaces

            if (currentIdc === "USA") {
                console.log("Using USA Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 6) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
                } else if (numericValue.length > 3) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
                } else {
                    formattedValue = numericValue;
                }
            } else if (currentIdc === "IND") {
                console.log("Using India Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 5) {
                    formattedValue = `${numericValue.slice(0, 5)}-${numericValue.slice(5)}`;
                } else {
                    formattedValue = numericValue;
                }
            }

            // Update the phone number only
            setViewFormData(prev => ({ ...prev, phone: formattedValue }));
            return; // Stop further execution for "phone" field
        } else if (name === "cost") {
            const numericValue = parseFloat(value.replace(/[^0-9.]/g, ""));
            setViewFormData(prev => ({ ...prev, [name]: isNaN(numericValue) ? "" : numericValue }));
        }

        else if (name === "manager") {
            for (let key in manager) {
                if (manager.hasOwnProperty(key) && manager[key].userid === value) {
                    setViewFormData(prev => ({ ...prev, [name]: value }));
                    break; // No need to continue looping after finding the match
                }
            }
        }

        else if (name === "status") {
            if (id) {
                setCheckStatus(true);
            }
            setViewFormData(prev => ({ ...prev, [name]: value }));
        } else if (name == "assignedCpc") {
            let assignedCpcValue = value.split("|")
            console.log("valddd ", value, assignedCpcValue[0], assignedCpcValue[1])
            setViewFormData(prev => ({ ...prev, "assignedCpc": assignedCpcValue[0], "assignedCpcTitle": assignedCpcValue[1] }));
        } else {
            setViewFormData(prev => ({ ...prev, [name]: value }));
        }
    };
    const handleChangeMultiSelect = (selected, key) => {
        setViewFormData({ ...viewFormData, [key]: selected });

    }
    function onConfirm() {
        setSuccess(false);
        navigate("/modules", { state: { restoreListPage: true } })
    };
    console.log('viewFormData', viewFormData)
    function onUpdateConfirm() {
        setUpdateSuccess(false);
        getuser()

        if (imageFiles && imageFiles.length > 0) {
            setImageUrls(null);
            setImageFiles([])
            setImageIndex(0)
        }

        if (clinicalimageFiles && clinicalimageFiles.length > 0) {
            setClinicalImageUrls(null);
            setclinicalImageFiles([])
            setClinicalImageIndex(0)
        }

    };



    function formvalidation() {
        GetTimeActivity()
        let formIsValid = true;

        if (viewFormData?.name === undefined || viewFormData?.name?.trim() === "") {
            setNameError("Please enter Name");
            formIsValid = false;
        } else {
            setNameError("")
        }

        if (viewFormData?.cost === undefined || viewFormData?.cost === null || viewFormData?.cost === "") {
            setCostError("Please enter Cost");
            formIsValid = false;
        } else {
            setCostError("")
        }

        // if (id && tags && tags?.length == 0) {
        //     settagError("Please enter Tags");
        //     // setTimeout(() => settagError(""), 3000);
        //     formIsValid = false;
        // } else {
        //     settagError("")
        // }

        // if (id && (viewFormData?.description === undefined || viewFormData?.description?.trim() === "")) {
        //     setdescriptionError("Please enter Clinical history");
        //     // setTimeout(function () { setdescriptionError("") }, 3000);
        //     formIsValid = false;
        // } else {
        //     setdescriptionError("")
        // }



        // if (id && !viewFormData?.explanation?.trim()) {
        //     setexplanationError("Please enter Explanation");
        //     //  setTimeout(() => setexplanationError(""), 3000);
        //     formIsValid = false;
        // } else {
        //     setexplanationError("")
        // }

        // if (id && !viewFormData?.answer1?.value) {
        //     setanswer1Error("Please select answer (1 Point)");
        //     //setTimeout(() => setanswer1Error(""), 3000);
        //     formIsValid = false;
        // } else {
        //     setanswer1Error("")
        // }


        // if (id && !viewFormData?.answer2?.value) {
        //     setanswer2Error("Please select answer (0.5 point)");
        //     setTimeout(() => setanswer2Error(""), 3000);
        //     formIsValid = false;
        // }

        // if (viewFormData?.status === undefined || viewFormData?.status?.trim() === "") {
        //     setstatusError("Please enter status");
        //     setTimeout(function () { setstatusError("") }, 3000);
        //     formIsValid = false;
        // }

        // if (viewFormData?.type === "ACCOUNTMANAGER" || viewFormData?.type === "CONTENTMANAGER" || viewFormData?.type === "MANAGER") {
        //     if (viewFormData?.manager === "" || viewFormData?.manager === undefined) {
        //         setManagerTypeError("Please select Manager");
        //         setTimeout(function () { setManagerTypeError("") }, 3000);
        //         formIsValid = false;
        //     }
        // }

        return formIsValid;
    }






    const handleBack = (e) => {
        GetTimeActivity()
        navigate("/modules", { state: { restoreListPage: true } })
    }

    const CancelClick = () => {
        GetTimeActivity()
        setIsMsg(false);
        navigate("/modules", { state: { restoreListPage: true } })
    }

    const getSelectedVideoFiles = (videos, selectedvideos) => {
        const selectedIds = selectedvideos.map((c) => c.value);

        // Filter matching cases and extract their files
        return videos
            .filter((c) => selectedIds.includes(c._id))
            .flatMap((c) => c); // merge all matched files into a single array
    };

    const getSelectedFiles = (cases, selectedcases) => {
        const selectedIds = selectedcases.map((c) => c.value);

        // Filter matching cases and extract their files
        return cases
            .filter((c) => selectedIds.includes(c.caseid))
            .flatMap((c) => c); // merge all matched files into a single array
    };

    const handleSelectAll = (e, updatedType, menuItemIndex, submenuIndex) => {
        const checked = e.target.checked;
        // console.log('menuItemIndex',menuItemIndex)
        // console.log('submenuIndex',submenuIndex)
        setPermission(prevState => {
            if (submenuIndex === undefined) {
                return prevState.map((menuItem, i) => {
                    if (i === menuItemIndex) {
                        const updatedDashboard = Object.keys(menuItem.dashboard).reduce((obj, key) => {
                            obj[key] = { ...menuItem.dashboard[key], [updatedType]: checked };
                            return obj;
                        }, {});
                        return { ...menuItem, [updatedType]: checked, dashboard: updatedDashboard };
                    }
                    return menuItem;
                });
            } else if (submenuIndex === "submenus") {
                return prevState.map((menuItem, i) => {
                    if (i === menuItemIndex) {
                        // console.log('menuItem.submenus',menuItem.submenus)
                        const updatedSubmenus = menuItem.submenus.map((submenu, j) => {

                            const kk = Object.keys(submenu.dashboard).reduce((obj, key) => {
                                obj[key] = { ...submenu.dashboard[key], [updatedType]: checked };
                                return obj
                            }, {});

                            return { ...submenu, [updatedType]: checked, dashboard: kk };

                        });
                        return { ...menuItem, [updatedType]: checked, submenus: updatedSubmenus };

                    }
                    return menuItem;
                });
            }

            else {

                return prevState.map((menuItem, i) => {
                    if (i === menuItemIndex) {
                        const updatedSubmenus = menuItem.submenus.map((submenu, j) => {
                            if (j === submenuIndex) {

                                const kk = Object.keys(submenu.dashboard).reduce((obj, key) => {
                                    obj[key] = { ...submenu.dashboard[key], [updatedType]: checked };
                                    return obj
                                }, {});

                                return { ...submenu, [updatedType]: checked, dashboard: kk };
                            }
                            return submenu;
                        });
                        return { ...menuItem, submenus: updatedSubmenus };
                    }
                    return menuItem;
                });
            }
        });
        // console.log('permissionss',permission)
    };

    const handleChangeEachItem = (e, index, subIndex, type, typeOfItem, updatedType, subSubIndex) => {
        const updatedPermission = [...permission];
        const isChecked = e.target.checked;
        // console.log('typeeee',type)
        // console.log('index',index)
        // console.log('subIndex',subIndex)
        // console.log('updatedPermission',updatedPermission)
        // console.log('typeOfItem',typeOfItem)
        if (typeOfItem === 'dashboard') {
            updatedPermission[index].dashboard[type][updatedType] = isChecked;
        } else if (typeOfItem === 'submenus') {
            updatedPermission[index].submenus[subSubIndex].dashboard[type][updatedType] = isChecked;
            if (isChecked && updatedPermission[index].dashboard) {
                Object.keys(updatedPermission[index].dashboard).forEach(key => {
                    updatedPermission[index].dashboard[key][updatedType] = true;
                });
            }
        }

        setPermission(updatedPermission);
    };


    const handlePopupload = (e) => {
        setPopupLoading(true)
    }

    const imageFileDelete = async (e) => {
        setdeleteImage(false)
        try {
            let params = {
                "source_bucket": resourceBucket,
                "sourcepath": deleteImageId?.sourcepath,
                "fileid": deleteImageId?.fileid
            }


            await tmdbApi.deleteModuleFiles(id, params);



            setDeleteImageSuccess(true)
        } catch {
            console.log("error");
        }
    }

    const onDelImageCancel = (e) => {
        setdeleteImage(false)
        setDeleteImageId(null)

    }

    const ondeleteImageConfirm = (e) => {
        setDeleteImageSuccess(false)
        // let deleteImageIndex = deleteImageId["index"]
        // if (deleteImageIndex > -1) { // only splice array when item is found
        //     viewFormData["historyfiles"].splice(deleteImageIndex, 1); // 2nd parameter means remove one item only
        // }
        setDeleteImageId(null)
        // let imgIndex = clinicalimageIndex
        // setClinicalImageIndex(imgIndex - 1)
        getuser()
    }

    // console.log("imageFiles", imagesUrls, imageFiles);



    const handleSelectChange = (selectedOption, aIndex) => {
        setViewFormData((prevData) => ({
            ...prevData,
            [aIndex]: selectedOption // Update the 'description' field with Quill editor value
        }));
    }

    const handleInputChange = (inputValue, aIndex) => {

        if (inputValue !== "") {
            const results = answers?.filter(option =>
                option.label.toLowerCase().includes(inputValue.toLowerCase())
            );
            setFilteredOptionsMap(prev => ({
                ...prev,
                [`${aIndex}`]: results
            }));
        } else {
            setFilteredOptionsMap(prev => ({
                ...prev,
                [`${aIndex}`]: answers
            }));
        }
    };


    console.log("clinicalimageFilessssssssssssssssssssssssss", clinicalimageFiles);
    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <SideMenu />
                {/* <SweetAlert show={invalidContent}
                    custom
                    confirmBtnText="ok"
                    confirmBtnBsStyle="primary"
                    title={"User Not Found"}
                    onConfirm={e => onclickInvalid()}
                >
                </SweetAlert> */}
                {!invalidContent &&

                    <div className="main-content user-management create-user edit-module-page" id="main-content">
                        <div className="page-content" id="page-content">
                            <div className="container-fluid" id="container-fluid">
                                <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                    <div className="col-lg-12">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                <h4 className="mb-2 card-title" id="breadcrumb-title">{id === undefined ? "MODULE DETAILS" : "VIEW MODULE"}</h4>
                                                <p className="menu-path" id="breadcrumb-path">
                                                    <span>Learning Hub</span> / <b id="breadcrumb-action">{id === undefined ? "ADD MODULE" : "VIEW MODULE"}</b>
                                                </p>
                                            </div>
                                            <div>
                                                <a id="back-button" onClick={handleBack} className="stroke-btn-style create-quiz-btn">back
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="create-user-block" id="create-user-block">

                                    {!loading && Object.keys(viewFormData)?.length > 0 ? (
                                        <>
                                            <div className="form-block" id="form-block">
                                                <div className="row">
                                                    <div className="d-flex flex-wrap col-lg-12 col-md-12 justify-content-between align-items-start">
                                                        <div className="col-lg-6 col-md-12">

                                                            <div className="col-lg-12 col-md-12">
                                                                <div className="mb-3 input-field">
                                                                    <label className="form_label">Name</label>
                                                                    <input id="name" name="name" placeholder="Enter Name" type="text" disabled className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={viewFormData?.name || "N/A"} />
                                                                    <span id="name-error" disabled className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{nameError}</span>
                                                                </div>
                                                            </div>


                                                            <div className="col-lg-12 col-md-12">
                                                                <div className="mb-3 input-field clinical-history">
                                                                    <label className="form-label form-label">Description
                                                                        {/* {id && <span className="required">*</span>} */}
                                                                    </label>

                                                                    <Editor disabled name="description" value={viewFormData?.description || "N/A"} onChange={(e) => onDescriptionChange(e, 'description')} />

                                                                    <span id="status-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{descriptionError}</span>



                                                                </div>
                                                            </div>
                                                            <div className="col-lg-12 col-md-12 editmodule-tags">
                                                                <div className="mb-3 input-field">

                                                                    <label className="form_label">Tags
                                                                    </label>

                                                                    <div className="mb-3 input-field">

                                                                        <div
                                                                            onClick={handleClickContainer}
                                                                            style={{
                                                                                display: "flex",
                                                                                flexWrap: "wrap",
                                                                                border: "1px solid #ccc",
                                                                                borderRadius: "4px",
                                                                                padding: "5px",
                                                                                cursor: "text",
                                                                                minHeight: "40px",
                                                                                alignItems: "center",

                                                                            }}
                                                                        >
                                                                            {tags.map((tag, index) => (
                                                                                <div
                                                                                    key={index}
                                                                                    style={{
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        background: "#e0e0e0",
                                                                                        borderRadius: "4px",
                                                                                        padding: "2px 6px",
                                                                                        margin: "2px",
                                                                                    }}
                                                                                >
                                                                                    {tag}

                                                                                </div>
                                                                            ))}
                                                                            <input
                                                                                ref={inputRef}
                                                                                value={input}
                                                                                onChange={(e) => setInput(e.target.value)}
                                                                                onKeyDown={handleKeyDown}
                                                                                style={{
                                                                                    flex: 1,
                                                                                    border: "none",
                                                                                    outline: "none",
                                                                                    minWidth: "80px",
                                                                                }}
                                                                                placeholder={tags?.map?.length>0 ? "" :"N/A"}
                                                                                disabled

                                                                            />

                                                                        </div>






                                                                        <span id="tag-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{tagError}</span>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <div className="row col-lg-12 col-md-12">
                                                                <div className="col-lg-6 edit-module-select-fields">

                                                                    <div className="col-lg-12 col-md-12">
                                                                        <div className="mb-3 input-field">
                                                                            <label className="form_label" htmlFor="module-select">
                                                                                MODULE TYPE
                                                                            </label>
                                                                            <input disabled id="cost" name="moduletype" placeholder="No module type" type="text" className="form-control" aria-invalid="false"

                                                                                // value={viewFormData?.type} 
                                                                                value={viewFormData?.type || "N/A"}
                                                                            />


                                                                        </div>
                                                                    </div>

                                                                    <div className="col-lg-12 col-md-12">
                                                                        <div className="mb-3 input-field">
                                                                            <label className="form_label">Cost

                                                                                {/* <span className="required">*</span> */}
                                                                            </label>
                                                                            <input disabled id="cost" name="cost" placeholder="Enter Cost" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={viewFormData?.cost ?? "N/A"} />
                                                                            <span id="cost-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{costError}</span>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-lg-12 col-md-12">
                                                                        <div className="mb-3 input-field">
                                                                            <label className="form_label" htmlFor="usertype-select">
                                                                                STATUS
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                className="colorselect capitalize form-control"
                                                                                value={viewFormData?.status || "N/A"}
                                                                                disabled
                                                                            />


                                                                        </div>
                                                                    </div>
                                                                    {/* <div className="col-lg-6"></div> */}




                                                                </div>
                                                                <div className="col-lg-6 col-mb-12 mt-2 edit-module-upload-image">

                                                                    <div className="col-md-12 upload-imgs-edit-mod">
                                                                        <div className="d-flex col-lg-12 align-items-start justify-content-between upload-img-section">
                                                                            <label className="form_label col-12">Image</label>
                                                                        </div>

                                                                        <div className="d-flex justify-content-start col-lg-12 clinical-photo-section gap-3 mt-1">



                                                                            {/* Uploaded clinical images */}
                                                                            {/* THUMBNAIL GRID */}
                                                                            <div className="uploaded_images-grid mt-0 no-img-block" /* grid container */>
                                                                                {/* ── Clinical images from local upload ─────────────────── */}
                                                                                <div className="upload-box">
                                                                                    <div className="file_upload add-box">

                                                                                        <label htmlFor="file-upload" className="Add-btn d-flex align-items-center justify-content-center flex-column">
                                                                                            <p className="mb-0">

                                                                                            </p>
                                                                                            No image
                                                                                        </label>
                                                                                    </div>


                                                                                    {/* <div className="file_requirements mt-2 small text-muted">
                                                                                <p className="mb-1">File size: 20 MB</p>
                                                                                <p className="mb-0">Formats: JPG, PNG</p>
                                                                            </div> */}
                                                                                    {/* <p className="mt-0 mb-0 text-start col-12 file-format upload-img-note">Note: File size: 5 MB | Supported Formats: JPG, PNG</p> */}

                                                                                </div>

                                                                                {clinicalimagesUrls &&
                                                                                    Object.keys(clinicalimagesUrls).map((item, key) => (
                                                                                        <div className="thumb-box" key={key}>
                                                                                            <div
                                                                                                className="thumb-img cursor-pointer"
                                                                                                onClick={() => handlePopupImage(clinicalimagesUrls[item].url)}
                                                                                            >
                                                                                                <img
                                                                                                    src={clinicalimagesUrls[item].url}
                                                                                                    alt="uploaded"
                                                                                                />

                                                                                                {/* <span
                                                                                                    className="icon-close"
                                                                                                    onClick={(e) => {
                                                                                                        e.stopPropagation();
                                                                                                        handleClinicalImageDelete(e, item, key, "file");
                                                                                                    }}
                                                                                                >
                                                                                                    ×
                                                                                                </span> */}
                                                                                            </div>
                                                                                            {/* <p className="thumb-name text-truncate small mb-0">
                                                                                            {clinicalimagesUrls[item].name}
                                                                                        </p> */}
                                                                                        </div>
                                                                                    ))}



                                                                                {/* ── Clinical images from viewFormData.historyfiles ─────────── */}
                                                                                {viewFormData?.modulefiles?.length > 0 &&
                                                                                    viewFormData.modulefiles.map((item, key) => {
                                                                                        const imagePath = `${imageCloudfront}${item?.sourcepath?.replace(/ /g, '%20')
                                                                                            }?auto=compress,format`;
                                                                                        return (
                                                                                            <div className="thumb-box" key={key}>
                                                                                                <div
                                                                                                    className="thumb-img cursor-pointer"
                                                                                                    onClick={() => handlePopupImage(imagePath)}
                                                                                                >
                                                                                                    <img src={`${imagePath}&width=150`} alt="history" />

                                                                                                    {/* <span
                                                                                                        className="icon-close"
                                                                                                        onClick={(e) => {
                                                                                                            e.stopPropagation();
                                                                                                            handleImageFileDelete(e, item, key, 'file');
                                                                                                        }}
                                                                                                    >
                                                                                                        ×
                                                                                                    </span> */}

                                                                                                </div>
                                                                                                {/* <p className="thumb-name text-truncate small mb-0">
                                                                                                {item.filename}
                                                                                            </p> */}
                                                                                            </div>
                                                                                        );
                                                                                    })}
                                                                            </div>

                                                                        </div>
                                                                    </div>


                                                                    <div className="row col-lg-12 mt-4">
                                                                        <div className="d-flex justify-content-start col-lg-12 histology-photo-section gap-2 mt-3">

                                                                            <div className="mb-3 mt-2 input-field deep-zoom-styles">

                                                                                {imagesUrls &&
                                                                                    Object.keys(imagesUrls).length > 0 &&
                                                                                    Object.keys(imagesUrls).map((item, key) => (
                                                                                        <div className="upload_images d-flex gap-2 align-items-start" key={key}>
                                                                                            <div className="img">
                                                                                                <p className="text-truncate small mb-0">{imagesUrls[item].name}</p>
                                                                                                <span className="default-img"><img src={deepZoom} alt="" /></span>

                                                                                            </div>

                                                                                            {/* <span
                                                                                                onClick={(e) => handleImageDelete(e, item)}
                                                                                                className="icon-close"
                                                                                            >
                                                                                                x
                                                                                            </span> */}
                                                                                        </div>
                                                                                    ))}



                                                                            </div>


                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    {viewFormData?.type === "Timed Module" &&
                                                                        <div className="row access-code-reponsive">

                                                                            {/* Schedule From */}
                                                                            <div className="mb-1 col-md-6 col-sm-12">
                                                                                <label className="form-label">Schedule From</label>
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control"
                                                                                    disabled
                                                                                    value={
                                                                                        viewFormData?.scheduleDate
                                                                                            ? dayjs(viewFormData.scheduleDate).format("DD/MM/YYYY HH:mm")
                                                                                            : "N/A"
                                                                                    }
                                                                                />
                                                                            </div>

                                                                            {/* Schedule To */}
                                                                            <div className="mb-1 col-md-6 col-sm-12">
                                                                                <label className="form-label">Schedule To</label>
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control"
                                                                                    disabled
                                                                                    value={
                                                                                        viewFormData?.scheduleEndDate
                                                                                            ? dayjs(viewFormData.scheduleEndDate).format("DD/MM/YYYY HH:mm")
                                                                                            : "N/A"
                                                                                    }
                                                                                />
                                                                            </div>

                                                                        </div>}

                                                                    <div className="col-lg-12 ">
                                                                        {viewFormData.type === "Timed Module" &&
                                                                            <div className="col-lg-12 col-md-12">
                                                                                <div className="mb-3 input-field" style={{ position: "relative" }}>
                                                                                    <label className="form_label">
                                                                                        Access Code
                                                                                    </label>

                                                                                    <input
                                                                                        id="AccessCode"
                                                                                        name="accessCode"
                                                                                        placeholder="Enter Access Code"
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        aria-invalid="false"
                                                                                        // onChange={(e) => handleChange(e)}
                                                                                        value={viewFormData?.accessCode || "N/A"}
                                                                                        style={{ paddingRight: "90px" }}  // space for button
                                                                                    />

                                                                                    {/* Generate Button Inside Input */}



                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>




                                                        </div>


                                                        <div className="row col-lg-5 col-md-12 video-edit-section">
                                                            {/* {viewFormData?.files && viewFormData?.files.length > 0 && */}
                                                            {/* <div className="col-lg-12 col-md-12">
                                                                <div className="mb-3 input-field">
                                                                    <label className="form_label">Cases </label>
                                                                    {cases && (
                                                                        <Select
                                                                            isMulti
                                                                            value={selectedCases || []}
                                                                            options={
                                                                                Array.isArray(cases)
                                                                                    ? cases
                                                                                        .filter((item) => item.diagnosis)
                                                                                        .map((eachItem) => ({
                                                                                            value: `${eachItem.caseid}`,
                                                                                            // label: eachItem.diagnosis,
                                                                                            label: eachItem.diagnosisid
                                                                                                ? `${eachItem.diagnosisid} ${eachItem.diagnosis}`
                                                                                                : eachItem.diagnosis,
                                                                                            diagnosisid: eachItem.diagnosisid,
                                                                                            diagnosis: eachItem.diagnosis,
                                                                                        }))
                                                                                    : []
                                                                            }
                                                                            isClearable={false}
                                                                            components={{ MultiValueRemove: () => null }}
                                                                            name="cases"
                                                                            onChange={handleCaseChange}
                                                                            placeholder="N/A"
                                                                            classNamePrefix="my-select"
                                                                            isDisabled

                                                                        />
                                                                    )}
                                                                    {errors?.cases && <div className="text-danger">{errors.cases}</div>}
                                                                </div>
                                                            </div> */}
                                                            {/* } */}

                                                            <div className="col-lg-12 col-md-12 edit-module-cases">
                                                                {selectedCases?.length > 0 && selectedfileslist?.length > 0 && (
                                                                    <div className="table-responsive mt-2">
                                                                        <table style={caseTableStyle}>
                                                                            <thead>
                                                                                <tr>
                                                                                    <th style={{ ...caseThStyle, width: "30px" }}>#</th>
                                                                                    <th style={caseThStyle}>Case</th>
                                                                                    <th style={{ ...caseThStyle, width: "60px" }}>Image</th>
                                                                                    <th style={{ ...caseThStyle, width: "70px" }}>Actions</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {selectedfileslist.map((file, key) => (
                                                                                    <tr key={file?.value || key}>
                                                                                        <td style={{ ...caseTdStyle, backgroundColor: caseRowBg(key) }}>{key + 1}</td>
                                                                                        <td style={{ ...caseTdStyle, backgroundColor: caseRowBg(key) }}>{file?.diagnosisid ? `${file.diagnosisid} ${file.diagnosis}` : file?.diagnosis}</td>
                                                                                        <td style={{ ...caseTdStyle, backgroundColor: caseRowBg(key) }}>
                                                                                            <img
                                                                                                src={file?.files?.[0]?.thumbnailUrl ? `${imageCloudfront}${file?.files?.[0]?.thumbnailUrl.replace(/^\/+/, '').replace(/ /g, '%20')}` : deepZoom}
                                                                                                alt=""
                                                                                                style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "4px" }}
                                                                                            />
                                                                                        </td>
                                                                                        <td style={{ ...caseTdStyle, backgroundColor: caseRowBg(key) }}>
                                                                                            <div style={{ display: "inline-flex" }}>
                                                                                                <a onClick={(e) => editCaseLink(e, file)}
                                                                                                    style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: "34px", height: "30px", backgroundColor: "#fff", border: "1px solid #d5d5d5", borderRadius: "5px", cursor: "pointer" }}
                                                                                                    title="View"><i
                                                                                                        className="mdi mdi-eye" style={{ fontSize: "17px", lineHeight: 1, color: "#000" }}></i></a>
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                )}
                                                                {/* {(!selectedCases || selectedCases.length === 0) && (
  <div className="text-muted">N/A</div>
)} */}

                                                            </div>



                                                            <div className="col-lg-12 col-md-12 mt-3">
                                                                <div className="mb-3 input-field">
                                                                    <label className="form_label">Videos </label>
                                                                    {Array.isArray(videos) && (
                                                                        <Select
                                                                            isMulti
                                                                            value={selectedVideos || []}
                                                                            options={
                                                                                Array.isArray(videos)
                                                                                    ? videos
                                                                                        .filter((item) => item.youtube != "")
                                                                                        .map((eachItem) => ({
                                                                                            value: `${eachItem._id}`,
                                                                                            label: eachItem.title,
                                                                                        }))
                                                                                    : []
                                                                            }
                                                                            name="videos"
                                                                            onChange={handleVideoChange}
                                                                            placeholder="N/A"
                                                                            isDisabled
                                                                            classNamePrefix="my-select"

                                                                        />


                                                                    )}
                                                                    {errors?.videos && <div className="text-danger">{errors.videos}</div>}




                                                                </div>
                                                            </div>



                                                            <div className="col-lg-12 col-md-12 row video-edit-module-section">

                                                                {selectedVideosFiles.map((file, key) => (


                                                                    <div className="col-lg-4" style={{ marginTop: "10px" }}>
                                                                        <img
                                                                            src={`https://img.youtube.com/vi/${getYouTubeVideoId(
                                                                                file?.youtube
                                                                            )}/0.jpg`}
                                                                            alt="YouTube Thumbnail"
                                                                            style={{
                                                                                width: "100%",
                                                                                maxWidth: "300px",
                                                                                cursor: "pointer",
                                                                            }}

                                                                            onClick={() => playVideo(file.youtube)}
                                                                        />
                                                                        <p className="d-flex justify-content-start align-items-center gap-2"
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={() => playVideo(file.youtube)}
                                                                        >
                                                                            {/* <span className="material-symbols-outlined">
                                                                                    smart_display
                                                                                </span>  */}
                                                                            <span className="pre-vid-txt">{file.title}</span>
                                                                        </p>
                                                                    </div>
                                                                ))}


                                                                {/* {selectedVideosFiles?.length === 0 && (
  <div className="text-muted">N/A</div>
)} */}

                                                                {showVideoPopup && (
                                                                    <div className="image-module-popup"
                                                                        style={{
                                                                            position: "fixed",
                                                                            top: 0,
                                                                            left: 0,
                                                                            width: "100%",
                                                                            height: "100%",
                                                                            backgroundColor: "rgba(0,0,0,0.8)",
                                                                            zIndex: 1000,
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                        }}
                                                                        onClick={() => setShowVideoPopup(false)}
                                                                    >
                                                                        <div style={{ position: "relative", width: "80%", maxWidth: "800px" }}>
                                                                            <iframe
                                                                                width="100%"
                                                                                height="450"
                                                                                src={`https://www.youtube.com/embed/${getYouTubeVideoId(
                                                                                    youtube
                                                                                )}`}
                                                                                frameBorder="0"
                                                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                                                allowFullScreen
                                                                                title="Video Preview"
                                                                            ></iframe>
                                                                            {/* <button className="create-quiz-btn"
                                                                                onClick={() => setShowVideoPopup(false)}
                                                                                style={{
                                                                                    position: "absolute",
                                                                                    top: 10,
                                                                                    right: 10,
                                                                                    border: "none",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                            >
                                                                                X
                                                                            </button> */}
                                                                            <button
                                                                                className="dz_close"
                                                                                onClick={() => setShowVideoPopup(false)}

                                                                                style={{
                                                                                    position: "absolute",
                                                                                    top: 10,
                                                                                    right: 10,
                                                                                    cursor: "pointer",
                                                                                    borderRadius: "6px",
                                                                                }}
                                                                            >
                                                                                <span className="material-symbols-outlined">close</span>
                                                                            </button>

                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>


                                                            <style>
                                                                {
                                                                    `
                                                                textarea.form-control {
                                                                min-height: calc(6.5em + .75rem + 2px) !important;}
                                                                `
                                                                }
                                                            </style>
                                                            {/*  */}






                                                        </div>



                                                    </div>




                                                </div>
                                                <div className="line">

                                                </div>
                                            </div>


                                        </>
                                    ) : (
                                        <div className="form-block" id="loading-block">
                                            <div className="tab-content p-3 text-muted">
                                                <div className="tab-pane active show" id="home1" role="tabpanel">
                                                    <div className="row">
                                                        <Loader />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <Footer id="footer" />
                    </div>

                }


                {showImagePopup && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0,0,0,0.8)",
                            zIndex: 1003,
                            display: "flex",
                            alignItems: "start",
                            justifyContent: "center",
                            padding: "20px", // padding all around
                        }}
                        onClick={() => setShowImagePopup(false)}
                    >
                        <div
                            style={{
                                position: "relative",
                                width: "auto",
                                height: "100%",
                                padding: "20px", // inner padding so image doesn't touch edges
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "start",
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <img
                                src={popupImage}
                                style={{
                                    maxWidth: "100%",
                                    maxHeight: "100%",
                                    objectFit: "contain",
                                    display: "block",
                                }}
                            />

                            <button
                                className="dz_close"
                                onClick={() => setShowImagePopup(false)}
                                style={{
                                    position: "absolute",
                                    top: 30,
                                    right: 30,
                                    cursor: "pointer",
                                    borderRadius: "6px",
                                }}
                            >
                                <span className="material-symbols-outlined">close</span>
                            </button>
                        </div>
                    </div>


                )}

            </div>



            {isPopupOpen && !dziUrl && (
                <div className="image-module-popup"
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 999,
                    }}
                    onClick={() => setPopupOpen(false)}
                >
                    <div className="popup_wrp"
                        style={{
                            position: "relative",
                            background: "white",
                            padding: "10px",
                            borderRadius: "10px",
                            maxWidth: "90vw",
                            maxHeight: "90vh",

                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Close Button */}
                        <button
                            style={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                background: "white",
                                color: "#000",
                                border: "none",

                                cursor: "pointer",
                                borderRadius: "5px",
                            }}
                            onClick={() => setPopupOpen(false)}
                        >
                            <span className="material-symbols-outlined">
                                close
                            </span>
                        </button>

                        {/* Zoomable Image */}

                        <TransformWrapper ref={transformRef} initialScale={1}>
                            <div style={{ textAlign: "left", marginBottom: "10px" }}>
                                <button onClick={() => transformRef.current.zoomIn()} className="btnzoom" ><span className="material-symbols-outlined"> add </span></button>
                                <button onClick={() => transformRef.current.zoomOut()} className="btnzoom"><span className="material-symbols-outlined"> remove </span></button>
                                <button onClick={() => transformRef.current.resetTransform()} className="btnzoom"><span className="material-symbols-outlined"> refresh </span></button>
                            </div>

                            <TransformComponent>


                                {isPopupLoading && <div style={{ width: "400px", height: "400px" }}><Loader /> </div>}

                                <LazyLoadImage
                                    src={dzipopupImage + `? auto = compress, format`}
                                    effect="blur"
                                    onLoad={() => setPopupLoading(false)}
                                    style={{ width: "100%", borderRadius: "10px" }}
                                />

                            </TransformComponent>
                        </TransformWrapper>
                    </div>
                </div>
            )}

            {/* Deep Zoom Popup */}
            {isPopupOpen && dziUrl && (
                <div className="deep_zoom">
                    <div
                        style={{
                            position: "fixed",
                            top: '0',
                            left: '0',
                            right: '0',
                            bottom: '0',
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 999,
                            borderRadius: "18px"
                        }}
                    >
                        <div style={{
                            width: "98vw",
                            height: "98vh",
                            position: "relative",
                            backgroundColor: "black",
                            overflow: "hidden"
                        }}>
                            {/* Deep Zoom Header */}
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "10px 20px",
                                backgroundColor: "#f8f9fa",
                                borderBottom: "1px solid #dee2e6"
                            }}>
                                <h3 style={{ fontSize: "18px" }}>
                                    {/* {dziUrlFile ? dziUrlFile : ""} */}
                                </h3>
                                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                    {/* <button
                                    className="create-quiz-btn border-0"
                                    onClick={resetZoom}
                                >
                                    Reset View
                                </button> */}
                                    {/* <button
                                    onClick={() => rotateImage(90)}
                                    className="create-quiz-btn border-0"

                                >
                                    Rotate 90°
                                </button> */}
                                    <button
                                        className="dz_close"
                                        onClick={closeDeepZoom}
                                        style={{
                                            border: "none",
                                            fontWeight: "800",
                                            borderRadius: "6px",
                                        }}
                                    >
                                        <span className="material-symbols-outlined">close</span>
                                    </button>
                                </div>
                            </div>

                            {/* Deep Zoom Viewer Container */}
                            <div style={{
                                height: "calc(95vh - 80px)",
                                width: "100%",
                                position: "relative"
                            }}>
                                <div
                                    id="openseadragon-viewer"
                                    ref={viewerRef}
                                    style={{
                                        height: "100%",
                                        width: "100%"
                                    }}
                                />

                                {/* Instructions */}
                                {/* <div style={{
                                position: "absolute",
                                bottom: "20px",
                                left: "20px",
                                backgroundColor: "rgba(0, 0, 0, 0.7)",
                                color: "white",
                                padding: "10px",
                                borderRadius: "5px",
                                fontSize: "12px"
                            }}>
                                <p style={{ margin: "2px 0" }}>• Zoom with mouse wheel or pinch gesture</p>
                                <p style={{ margin: "2px 0" }}>• Pan by clicking and dragging</p>
                                <p style={{ margin: "2px 0" }}>• Use the navigator in the bottom-right for orientation</p>
                                <p style={{ margin: "2px 0" }}>• Use toolbar buttons to rotate or reset view</p>
                            </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            )}


            {dziUrl && (
                <section className="viewer-section">
                    <div className="viewer-header">
                        <h2>Deep Zoom Viewer</h2>
                        <div className="viewer-controls">
                            <button className="control-button" onClick={() => window.location.reload()}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 2v6h-6"></path>
                                    <path d="M3 12a9 9 0 0 1 15-6.7L21 8"></path>
                                    <path d="M3 22v-6h6"></path>
                                    <path d="M21 12a9 9 0 0 1-15 6.7L3 16"></path>
                                </svg>
                                <span>Reset</span>
                            </button>
                        </div>
                    </div>

                    <div className="viewer-container">
                        <div id="openseadragon-viewer" ref={viewerRef}></div>
                        <div className="viewer-instructions">
                            <p>• Zoom with mouse wheel or pinch gesture</p>
                            <p>• Pan by clicking and dragging</p>
                            <p>• Use the navigator in the bottom-right for orientation</p>
                        </div>
                    </div>
                </section>
            )}


            <ToastContainer
                id="toastContainer"
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />

            {/* <SweetAlert
                show={uploadImg}
                title={"File Uploading......"}
                showConfirm={false} // Hides the OK button
            ></SweetAlert> */}


            <SweetAlert show={deleteImageSuccess}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={"Deleted Successfully"}
                onConfirm={e => ondeleteImageConfirm()}
            >
            </SweetAlert>

            <SweetAlert show={success}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={successMsg}
                onConfirm={e => onConfirm()}
            >
            </SweetAlert>

            <SweetAlert show={UpdateSuccess}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={successMsg}
                onConfirm={e => onUpdateConfirm()}
            >
            </SweetAlert>
            <SweetAlert show={alertMsg}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={"Please complete Cases, Module, and Description to activate."}
                onConfirm={e => setAlertMsg(false)}
            >
            </SweetAlert>
            <SweetAlert show={deleteImage}
                warning
                showCancel
                confirmBtnText="Yes"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Are you sure you want to delete?"
                focusCancelBtn
                onConfirm={e => imageFileDelete(e)}
                onCancel={e => onDelImageCancel(e)}
            >
            </SweetAlert>

            <SweetAlert show={alertPopup}
                warning
                confirmBtnText="Ok"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Maximum 10 files allowed"
                focusCancelBtn
                onConfirm={e => setAlertPopup(false)}
            >
            </SweetAlert>
            {/* <SweetAlert show={alertMsg}
                warning
                confirmBtnText="Ok"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Please complete Cases, Module, and Description to activate."
                focusCancelBtn
                onConfirm={e => setAlertMsg(false)}
            >
            </SweetAlert> */}

            <SweetAlert
                show={uploadImg}
                showConfirm={false}
                title=""
            //  onConfirm={() => setAlert(null)}
            >
                <div className="d-flex flex-column align-items-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">File Uploading...</span>
                    </div>
                    <p className="mt-3">File is Uploading...</p>
                </div>
            </SweetAlert>

            <SweetAlert show={fileSizeError}
                warning
                confirmBtnText="ok"
                confirmBtnBsStyle="danger"
                title={fileSizeErrorMsg}
                onConfirm={e => setFileSizeError(false)}
            >
            </SweetAlert>

        </>
    );
};

export default EditTest;